<template>
  <div class="row">
    <div class="d-flex flex-row">
      <div class="p-2 w-25">
        <select class="form-control" v-model="cat_id" @change="serachByCat">
          <option value="">بدون دسته بندی</option>
          <option v-for="cat in cats" :value=cat.id>{{ cat.title }}</option>
        </select>
      </div>
      <div class="p-2 w-75">
        <div class="input-group">
          <input class="form-control py-2 border-right-0 border" v-model="search" type="search"
                 @keyup="seerachQuestions()"
                 placeholder="حستجو براساس سوال">
        </div>
      </div>
    </div>
    <div class="col-lg-11 w-100" style="margin-top: 30px">
      <btn_loading v-if="loading"></btn_loading>
      <section style="margin-top: 5px" class="card">
        <table class="table table-striped table-bordered">
          <thead>
          <tr>
            <th scope="col" colspan="3">
              <ul class="nav navbar-nav">
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  </a>
                  <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li class="text-center"><a class="dropdown-item" href="#" @click="btn_deleteArray()"> <i class="fa fa-trash text-danger"></i> حذف </a></li>
                  </ul>
                </li>
              </ul>
            </th>
            <th scope="col"> سوال</th>
            <th scope="col">گزینه یک</th>
            <th scope="col">گزینه دو</th>
            <th scope="col">گزینه سوم</th>
            <th scope="col">گزینه چهارم</th>
            <th scope="col">پاسخ صیحیح</th>
            <th scope="col">سطح سوال</th>
            <th scope="col"> دسته بندی</th>
            <th scope="col">عملیات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for=" (list , index ) in listQuestions">
            <td colspan="2" ><input type="checkbox" @click="addItme(list.id)" name="checkbox"></td>
            <td v-html="list.id"></td>
            <td v-html="list.question"></td>
            <td v-html="list.question_one"></td>
            <td v-html="list.question_two"></td>
            <td v-html="list.question_three"></td>
            <td v-html="list.question_four"></td>
            <td v-html="getAnswer(list.answers)"></td>
            <td>{{
                (list.level == 1) ? 'مقدماتی' : (list.level == 2) ? 'متوسط' : (list.level == 3) ? 'پیشرفته' : ""
              }}
            </td>
            <td v-html="list?.categorie.title"></td>
            <td class="text-center">
              <a href="#">
                <i class="fa fa-trash text-danger" @click="btn_delete(list.id)"></i>
                &nbsp;
                <router-link :to='`/panel/CreateQuestions/${list.id}`' class="title"><i class="fa fa-edit"> </i>
                </router-link>
              </a>

            </td>
          </tr>
          <tr>
            <td colspan="10">
              <nav class="text-danger">
                <ul class="pagination  " style="justify-content: center;">
                  <li class="page-item">
                    <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                            v-on:click="myPaginate(paginatetion.first_page_url)" title="اولین"><i
                        class="fa fa-angle-double-right"></i></button>
                    <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                            v-on:click="myPaginate(paginatetion.prev_page_url)" title="قبلی"><i
                        class="fa fa-angle-right"></i></button>
                  </li>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <li class="page-item">
                    <button class="btn btn-light" v-on:click="myPaginate(paginatetion.next_page_url)"
                            :disabled="!paginatetion.next_page_url" title="بعدی">
                      <i class="fa fa-angle-left"></i></button>

                    <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                            v-on:click="myPaginate(paginatetion.last_page_url)" title="اخرین"><i
                        class="fa fa-angle-double-left"></i></button>
                  </li>
                </ul>
              </nav>
            </td>
          </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
</template>
<script setup>
import config from "../../../../config/config.json";
import {useToast} from "vue-toastification";
import Btn_loading from "@/common/components/btn_loading.vue";
import {$ref} from "vue/macros";
import axios from "axios";

let listQuestions = $ref({});
let paginatetion = $ref({});
let search = "";
let url = `${config.BASE_URL}/Experiments`;

const toast = useToast();

let cats = $ref({});
let cat_id = "";
let list = [];
let loading = false;
const answers = {
  'one': 'گزینه یک',
  'two': 'گزینه یک',
  'three': 'گزینه یک',
  'four': 'گزینه یک',
}

function getAnswer(answerKey) {
  switch (answerKey) {
    case 'question_one':
      return 'گزینه یک';
    case 'question_two':
      return 'گزینه دو';
    case 'question_three':
      return 'گزینه سه';
    case 'question_four':
      return 'گزینه چهار';
    default:
      return 'گزینه معتبر نیست';
  }
}

function getCat() {
  axios.get(`${config.BASE_URL}/categories/lists`)
      .then(function (res) {
        return cats = res.data.data;
      })
      .catch(function (errors) {
        console.log(errors);
      });
}

function addItme(item) {
  const index = list.indexOf(item);
  if (index === -1) {
    list.push(item);
  } else {
    list.splice(index, 1);
  }
}

function seerachQuestions() {
  loading = true;
  if (search === "") {
    return getQuestions();
  }
  axios.get(url + '/' + search)
      .then(function (res) {
        loading = false;
        return listQuestions = res.data.data;
      })
      .catch(function (errors) {
        loading = false;
        console.log(errors);
      });
}

function serachByCat() {

  if (typeof cat_id === 'string') {
    return getQuestions();
  }
  axios.get(url + '/cat/' + cat_id)
      .then(function (res) {
        return listQuestions = res.data.data;
      })
      .catch(function (errors) {
        console.log(errors);
      });
}

function getQuestions() {

  loading = true;
  axios.get(url)
      .then(function (res) {
        loading = false;
        makePaginatetion(res.data.data);
        return listQuestions = res.data.data.data;

      })
      .catch(function (errors) {
        loading = false;
        console.log(errors);
      });
}

function btn_deleteArray() {
   if(arr.length === 0){
     toast.error("لطفا یک گزینه انتخاب کنید");

   }

  axios.post(`${url}/destroyArray`, {
    'list_id': list
  })
      .then(function (response) {
        getQuestions();
        list = [];
        if (response.data.status) return toast.success(response.data.messages);
      })
      .catch(function (error) {
        if (error.response.status === 422) {
          Object.values(error.response.data.errors).forEach(function (val, key) {
            toast.error(val[0]);
          });
        }
        if (error.response.status === 404) {
          toast.error(error.response.data.messages);
        }
      });

}

function btn_delete(id) {
  const toast = useToast();
  axios.get(`${url}/delete/${id}`)
      .then(function (response) {
        getQuestions();
        if (response.data.status) return toast.success(response.data.messages);
      })
      .catch(function (error) {
        if (error.response.status === 422) {
          Object.values(error.response.data.errors).forEach(function (val, key) {
            toast.error(val[0]);
          });
        }
        if (error.response.status === 404) {
          toast.error(error.response.data.messages);
        }
      });
}

function makePaginatetion(data) {
  let paginatetions = {
    current_page: data.current_page,
    last_page_url: data.last_page_url,
    next_page_url: data.next_page_url,
    prev_page_url: data.prev_page_url,
    first_page_url: data.first_page_url
  }
  paginatetion = paginatetions;
}

function myPaginate(urls) {
  url = urls;
  getQuestions()
}

getQuestions()
getCat()
</script>
